import { ParticipantViewModel } from 'stageclip-common';

import { Asset } from '../ReviewModal.types';

import { DeleteAssetModalContainer } from './DeleteAssetModalContainer';
import { SimpleModalId } from 'constants/modalId';
import { makeGuardedModal, GuardedModalContentComponentProps } from 'components/guardedModal/makeGuardedModal';

export type DeleteAssetModalProps = GuardedModalContentComponentProps<{
  asset: Asset;
  participantId: ParticipantViewModel['id'];
}>;

export const DeleteAssetModal = makeGuardedModal(SimpleModalId.DeleteVGParticipantAsset, DeleteAssetModalContainer);
